import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the Chrome Extension Manifest V3 Generator tool
 * Separated from view layer for maintainability
 */
export const manifestGeneratorFAQ: FAQItem[] = [
  {
    question: "What is a Chrome Extension Manifest?",
    answer:
      "The manifest.json file is a required configuration file for every Chrome extension. It tells Chrome what your extension does, what permissions it needs, which files to load, and how it should behave. Manifest V3 is the current version required for all new Chrome extensions published to the Chrome Web Store.",
  },
  {
    question: "What's the difference between Manifest V2 and V3?",
    answer:
      "Manifest V3 is the current standard (required for new extensions). Key differences: V3 uses service workers instead of background pages, requires host permissions to be declared separately, uses declarativeNetRequest instead of webRequest for some use cases, and has stricter security requirements. This tool generates V3 manifests only, as V2 is deprecated.",
  },
  {
    question: "What permissions should I request?",
    answer:
      "Only request permissions your extension actually needs. Common ones include 'activeTab' (access current tab), 'storage' (save data), 'scripting' (inject scripts), and 'tabs' (access tab information). Requesting too many permissions can make users hesitant to install your extension. The tool includes a list of common permissions with descriptions.",
  },
  {
    question: "What are host permissions?",
    answer:
      "Host permissions allow your extension to access content on specific websites. For example, 'https://*.google.com/*' lets your extension work on Google domains. You need host permissions if you use the 'scripting' permission to inject content scripts or access page content. Enter one permission per line in the tool.",
  },
  {
    question: "What is a background service worker?",
    answer:
      "A service worker is a JavaScript file that runs in the background, even when your extension's popup is closed. It's used for tasks like listening to events, managing alarms, handling messages between components, and performing background processing. In V3, service workers replace the background pages used in V2.",
  },
  {
    question: "What are content scripts?",
    answer:
      "Content scripts are JavaScript files that run in the context of web pages. They can read and modify the DOM, interact with page content, and communicate with your extension's other parts. You specify which URLs they run on using 'matches' patterns (e.g., 'https://*.example.com/*'). You can add multiple content scripts for different sites.",
  },
  {
    question: "How do I use the generated manifest.json?",
    answer:
      "After generating your manifest, download it and save it as 'manifest.json' in your extension's root directory. Make sure all the file paths referenced in the manifest (like 'popup.html', 'background.js', content scripts) actually exist in your extension folder. Then load your extension in Chrome for testing using 'chrome://extensions' in developer mode.",
  },
  {
    question: "Can I edit the manifest after generating it?",
    answer:
      "Yes! The generated manifest.json is a standard JSON file that you can edit with any text editor. You can add more fields, modify permissions, or adjust settings as needed. The tool provides a good starting point, but you can customize it further based on your extension's specific requirements.",
  },
  {
    question: "Is this tool free?",
    answer:
      "Yes, completely free with no registration required. You can generate as many manifest files as you need. There are no limits, no watermarks, and no hidden fees. It's part of our free tools collection to help developers build Chrome extensions faster and avoid common configuration mistakes.",
  },
];
